const exported = {
  ChangeLogTypes: {
    // map types to the typename on UserItemAction.courier
    // https://github.com/webedx-spark/infra-services/blob/main/libs/models/src/main/pegasus/org/coursera/ondemand/audittrail/UserItemAction.courier#L4-L10
    itemProgressStarted: 'itemProgressStarted',
    itemProgressComplete: 'itemProgressComplete',
    ItemProgressSubmitted: 'ItemProgressSubmitted',
    itemOutcomeOverrideUpdate: 'itemOutcomeOverrideUpdate',
    itemOutcomeOverrideDelete: 'itemOutcomeOverrideDelete',
    itemOutcomeHide: 'itemOutcomeHide',
    itemOutcomeUnhide: 'itemOutcomeUnhide',
    itemGradingComplete: 'itemGradingComplete',

    // learner-specific deadline/availability updates
    ItemDeadlineOverrideUpdate: 'ItemDeadlineOverrideUpdate',
    ItemAvailabilityOverrideUpdate: 'ItemAvailabilityOverrideUpdate',

    // plagiarism flag/comment update events
    itemCheatingCaseUpdate: 'itemCheatingCaseUpdate', // [FLEX-21803] deprecated, old events will still be this format and BE to backfill
    itemCheatingCaseStatusUpdate: 'itemCheatingCaseStatusUpdate',
    itemCheatingCaseEvidenceUpdate: 'itemCheatingCaseEvidenceUpdate',

    // progress reset events (used for UofL resitting)
    itemProgressReset: 'itemProgressReset',
    itemGradeReset: 'itemGradeReset',

    // individual learner exceptions
    itemTimeLimitUpdate: 'itemTimeLimitUpdate',
    itemMaxAttemptsUpdate: 'itemMaxAttemptsUpdate',
    itemMaxSubmissionPerTimedAttemptUpdate: 'itemMaxSubmissionPerTimedAttemptUpdate',

    itemSubmissionUnsubmitted: 'itemSubmissionUnsubmitted',
  },
};

export const { ChangeLogTypes } = exported;

export default exported;
